<template>
    <div>
        
        <v-row>
            <v-col>
                <p class="text-h5 font-weight-bold">
                    {{ collection.name }}
                </p>
            </v-col>
            <v-col align="right">
                <v-btn text @click="goToCollection">
                    Elenco completo
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <!-- per il numero di colonne potrei usare grid_3, grid_4 etc -->
        <Grid :items="collection.libraries"
              v-if="collection.isGrid"
              :loading="loading"
              prop="collectionImage"
              @click="onClick"
              v-bind="collection.componentProps"/>

        <Mosaic :items="collection.libraries"
                v-else-if="collection.isMosaic"
                :loading="loading"
                prop="collectionImage"
                @click="onClick"
                v-bind="collection.componentProps"/>

    </div>
</template>

<script>
import utility from '@/mixins/utility'

import Grid from '@/components/Grids/Simple'
import Mosaic from '@/components/Grids/Mosaic'

export default 
{
   name: 'Collection',

   mixins: [ utility ],

   components:
   {
    Grid,
    Mosaic
   },

   data: () => ({

   }),

   props:
   {
      collection:
      {
         type: Object,
         required: true
      },

      loading:
      {
        type: Boolean,
        default: false
      }
   },

   computed:
   {
     
   },

   methods:
   {
     onClick(library)
     {
        this.$emit('click', library)
     },

     goToCollection()
     {
        let collection = this.collection
        
        this.goTo({ name:'collection', params:{ slug:collection.slug, collection } })
     }
   },

   mounted()
   {

   }
}
</script>